module.exports = __webpack_public_path__ + "img/logo.82fd458.png";